<template>
  <button
    :class="['btn', { disabled: disabled || loading }, variantButton]"
    :type="type"
    :style="getStyle()"
    :disabled="disabled || loading"
    @click="emit('click')"
  >
    <span v-if="loading" class="btn-loading">
      <Icon name="mdi:loading" class="loading-icon" />
      {{ loadingText }}
    </span>

    {{ !loading ? text : '' }}
    <slot v-if="!loading" />
  </button>
</template>

<script lang="ts" setup>
import type  { ButtonHTMLAttributes } from 'vue'

const emit = defineEmits(['click'])
const { text } = defineProps({
  text: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: undefined
  },
  variantButton: {
    type: String as PropType<'primary' | 'secondary'>,
    default: 'primary'
  },
  type: {
    type: String as PropType<ButtonHTMLAttributes['type']>,
    default: 'button'
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingText: {
    type: String,
    default: 'Carregando...'
  }
})

const getStyle = () => {
  return { minHeight: '40px' }
}
</script>

<style lang="scss" scoped>
.btn {
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.btn.primary {
  background-color: var(--button-primary);
  color: var(--button-text-primary);
}

.btn.secondary {
  background-color: var(--button-secondary);
  color: var(--button-text-secondary);
}

.btn.disabled {
  cursor: not-allowed;
  color: inherit;
  background-color: var(--button-disabled);
}

.btn.btn-fill-w { width: 100%; }
.btn.btn-fill-h { height: 100%; }
.btn.btn-fill { width: 100%; height: 100%;}

.btn, .btn:hover, .btn:active, .btn:focus {
  outline: none;
}

.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.loading-icon {
  font-size: 22px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
